import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { VideoModalComponent } from './components/video-modal/video-modal.component';

@NgModule({
  declarations: [
    ConfirmationPopupComponent,
    VideoModalComponent
  ],
  imports: [
    CommonModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      timeOut: 4000,
      easing: 'ease-in-out',
      easeTime: 300
    })
  ],
  exports: [
    CommonModule,
    ToastrModule,
    ConfirmationPopupComponent,
    VideoModalComponent
  ]
})
export class SharedModule {}
